export default __webpack_public_path__ + "static/media/create-account-icon.5a17c0b9.png";